import { useEffect } from 'react'

export function useChatShortcuts(handlers: {
  onToggleDock: () => void
  onNextUnread: () => void
  onPrevUnread: () => void
  onEscape: () => void
}): void {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.shiftKey && event.key.toLowerCase() === 'x') {
        event.preventDefault()
        handlers.onToggleDock()
        return
      }
      if (event.altKey && event.key === 'ArrowDown') {
        event.preventDefault()
        handlers.onNextUnread()
        return
      }
      if (event.altKey && event.key === 'ArrowUp') {
        event.preventDefault()
        handlers.onPrevUnread()
        return
      }
      if (event.key === 'Escape') {
        if (document.querySelector('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]')) {
          return
        }
        handlers.onEscape()
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [handlers])
}
